import { render, staticRenderFns } from "./VolunteerEduNavBar.vue?vue&type=template&id=fa76ff06&scoped=true"
import script from "./VolunteerEduNavBar.vue?vue&type=script&lang=js"
export * from "./VolunteerEduNavBar.vue?vue&type=script&lang=js"
import style0 from "./VolunteerEduNavBar.vue?vue&type=style&index=0&id=fa76ff06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76ff06",
  null
  
)

export default component.exports